import type { Network } from "../types";

export const pocket: Network = {
  name: "Pocket",
  shareUrl: "https://getpocket.com/edit?url=[u]",
  icon: "/media/images/facebook-social-auth.svg",
  color: "#EF3F56",
};
